/** Complete Location and Service Portfolio publications share this hard cap. */
export const LOCATION_PROFILE_PORTFOLIO_MAX_ITEMS = 60 as const;
